export default __webpack_public_path__ + "static/media/autocad.4d8146ef.jpg";